import axios from "axios";
import config from "../config";

const axiosSingleton = axios.create();

axiosSingleton.defaults.baseURL = `${config.API_BASE_URL}`;
axiosSingleton.defaults.headers['Ocp-Apim-Subscription-Key'] = `${config.API_SUBSCRIPTION_KEY}`;

export default axiosSingleton;